import React from 'react';
import http from '../api';
import PopupFrameV2 from '../popup/PopupFrameV2';
import Button from './Button';

export class FirstDataSyncIntroPopup extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
        }
    }

    componentWillMount() {
    }

	componentDidMount() {
    
    }

    componentDidUpdate() {
    
    }

    componentWillUnmount(e) {
    
    }

    render() {
        return (
            <div>
                <div className="FirstDataSyncIntroPopup" style={{position:"fixed", zIndex: 99999}}>
                    <PopupFrameV2
                            className={"FirstDataSyncIntroPopupFrame"}
                            width={"auto"}
                            maxWidth={"90vw"}
                            // height={"90vh"}
                            maxHeight={"90vh"}
                            padding={"40px 0px 0px 0px"}
                            onClose={() => {
                                this.props.onClose(); // 상위에서 showFirstIntroPopup=false 처리
                            }}
                        >
                        <div className="flexBox" style={{flexDirection:'column', flexWrap:"nowrap", height:"100%", textAlign:"center", alignItems: "center"}}>
                            <div className="flexBox" style={{flex:"1", flexDirection:'column', flexWrap:"nowrap", textAlign:"center", alignItems: "center", padding:"0px 40px 0px 40px"}}>
                                <div style={{display:"flex", alignItems: "center"}}>
                                    <img className="logo" src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/0e962a7a54a126f4e37dde4810da9e4f7ad6f91e.png" style={{width:"100px", height:"auto"}}/>
                                    <div style={{display: "flex", alignItems: "center", marginLeft: "10px"}}>
                                        <div className="title" style={{fontWeight: "700", fontSize: "24px", fontFamily:"Roboto Flex", marginRight:"80px"}}>데이터 연동중이네요~<br/>우선 쇼핑몰분석을 해볼까요?</div>
                                    </div>
                                </div>
                                <div className="content" style={{display:"flex", overflow:"auto", fontSize:"16px", fontWeight:"600", fontFamily:"Roboto Flex",  marginTop:"30px"}}>
                                <>
                                    데이터 연동을 기다리는 동안 쇼핑몰을 분석해볼게요.<br/>
                                    올리신 상품들이 어떤 트렌드를 따라가고 있는지<br/>
                                    소비자타겟을 분석해서 판매전략을 짜드릴까요? 
                                </>
                                </div>
                            </div>
                            <div className='flexBox' style={{width: "100%", justifyContent: "center", height:"auto", marginTop: "50px"}}>
                                <div id="button" onClick={() => {
                                    this.props.onConfirm(); 
                                }}>{
                                    "예"
                                }</div>
                            </div>
                        </div>
                    </PopupFrameV2>
                </div>
            </div>
        )
    };
}